/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly productPhotos: ReadonlyArray<{
        readonly smallPath: string | null;
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileCarousel_item">;
    readonly " $refType": "SharedItemTile_item";
};
export type SharedItemTile_item$data = SharedItemTile_item;
export type SharedItemTile_item$key = {
    readonly " $data"?: SharedItemTile_item$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "photosLimit"
    },
    {
      "kind": "RootArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTileCarousel_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'e597c24718ae6b73f3c6ca01b4e36e57';
export default node;
